// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CourseItem_wrapper__OpZDr","skeleton-loading":"CourseItem_skeleton-loading__r2dNr"};